import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import { WarrantyBaseData } from "api/delek"
import styled from "styled-components"

const StyledItemContainer = styled.div<{ $hasBorder: boolean }>`
  box-sizing: border-box;
  text-align: center;
  margin: 0 236.5px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
    grid-gap: 20px;
    box-sizing: border-box;
    margin: 0;
    grid-template-columns: 1fr;
    border-bottom: ${({ $hasBorder }) =>
      $hasBorder ? "1px solid #e7e7e7" : "none"};
  }

  td,
  th {
    border: 1px solid ${(p) => p.theme.colors.darkGrey};
  }
  th {
    background-color: ${(p) => p.theme.colors.white};
  }
  td {
    background-color: transparent;
  }
`

const StyledHeader = styled(TableCell)`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
  color: ${(p) => p.theme.colors.black};
`

const StyledTD = styled(TableCell)`
  font-family: "OENAPRO";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  /* or 22px */
  color: ${(p) => p.theme.colors.black};
`

const StyledTableHeader = styled.h2`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.05em;
  color: ${(p) => p.theme.colors.black};
  margin: 0px;
  padding: 40px 0;
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
  }
`

const StyledTableFooter = styled.p`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
  color: ${(p) => p.theme.colors.black};
  text-align: center;
  margin: 0;
  margin-top: 40px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
  }
`

type Props = {
  data: WarrantyBaseData[]
}

const TableInContent = ({ data }: Props) => {
  return (
    <StyledItemContainer $hasBorder={false}>
      <StyledTableHeader>פירוט הארכות האחריות הפעילות</StyledTableHeader>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <StyledHeader align="center">רכיב</StyledHeader>
              <StyledHeader align="center">תיאור תופעה</StyledHeader>
              <StyledHeader align="center">משך הארכת אחריות</StyledHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .filter((_, ind) => ind !== data.length - 1)
              .map((row, ind) => (
                <TableRow key={ind.toString()}>
                  <StyledTD align="center">{row.component}</StyledTD>
                  <StyledTD align="center">{row.phenomenonDesc}</StyledTD>
                  <StyledTD align="center">{row.extensionDuration}</StyledTD>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <StyledTableFooter>
          {data[data.length - 1]?.component}
        </StyledTableFooter>
      </TableContainer>
    </StyledItemContainer>
  )
}

export default TableInContent
